import {FormsModule} from '@angular/forms';
import {OnInit} from '@angular/core';
import localeEnZa from '@angular/common/locales/en-ZA';
import {LOCALE_ID} from '@angular/core';
import {registerLocaleData} from '@angular/common';
import {signal} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {Router, NavigationStart, NavigationEnd} from '@angular/router';
import {inject} from '@angular/core';
import {filter} from 'rxjs/operators';
import {Component} from '@angular/core';
import {WaToastDataService} from '../../webawesome/components/toast/WaToastDataService/WaToastDataService';
import {WaPageComponent} from 'angular-awesome';
import {RouterOutlet} from '@angular/router';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaIconDirective} from 'angular-awesome';
import {WaTooltipDirective} from 'angular-awesome';
import {WaBadgeDirective} from 'angular-awesome';
import {WaPopoverDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaSwitchDirective} from 'angular-awesome';
import {WaTreeDirective} from 'angular-awesome';
import {WaTreeItemDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-app',
	templateUrl:'./WebsiteBoot.html',
	styles: [],
	styleUrls:['./WebsiteBoot.scss'
],
	viewProviders:[],
	animations:[],
	providers:[
		{provide: LOCALE_ID, useValue: 'en-ZA'}
],
	schemas:[],
	preserveWhitespaces:true,
	host:{
    '[style.width]': '"100%"',
    '[style.height]': '"100%"',
 }
,
	imports:[
		FormsModule,
		WaPageComponent,
		RouterOutlet,
		RouterModule,
		WaButtonDirective,
		WaIconDirective,
		WaTooltipDirective,
		WaBadgeDirective,
		WaPopoverDirective,
		MarkdownComponent,
		WaSwitchDirective,
		WaTreeDirective,
		WaTreeItemDirective,
],
	standalone:true
})
export class WebsiteBoot implements OnInit
{
	private router: Router = inject(Router);
	private _asideNavigating = false;
	private document = inject(DOCUMENT);
	darkMode = signal(true);
	prismTheme = 'prism-solarizedlight';
	useGradle = false;
	private _prismThemeCache: Record<string, string> = {};
	private asideRoutes: Record<string, string> = {
    '': 'home',
    'home': 'home',
    'about': 'about',
    'getting-started': 'getting-started',
    'architecture': 'architecture',
    'capabilities': 'capabilities',
    'real-time': 'real-time',
    'plugins': 'plugins',
    'frameworks': 'frameworks'
};
	mdContent_0 = `\`\`\`xml
<repository>
    <id>guicedee-github</id>
    <url>https://maven.pkg.github.com/GuicedEE/*</url>
    <snapshots>
        <enabled>true</enabled>
    </snapshots>
</repository>
\`\`\``;
	mdContent_1 = `\`\`\`groovy
repositories {
    maven {
        url = uri("https://maven.pkg.github.com/GuicedEE/*")
        credentials {
            username = project.findProperty("gpr.user")
                ?: System.getenv("GITHUB_USER")
            password = project.findProperty("gpr.token")
                ?: System.getenv("GITHUB_TOKEN")
        }
    }
}
\`\`\``;
	ngOnInit()
	{
		registerLocaleData(localeEnZa, 'en-ZA')
		const savedTheme = localStorage.getItem('jwebmp-theme');
const prefersDark = savedTheme ? savedTheme === 'dark' : true;
this.darkMode.set(prefersDark);
this.document.body.classList.toggle('wa-dark', prefersDark);
		const savedPrismTheme = localStorage.getItem('jwebmp-prism-theme');
if (savedPrismTheme) {
    this.prismTheme = savedPrismTheme;
    this.changePrismTheme(null);
}
		const savedBuildTool = localStorage.getItem('jwebmp-build-tool');
if (savedBuildTool) {
    this.useGradle = savedBuildTool === 'gradle';
}
		this.router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe((e: any) => {
    if (this._asideNavigating) return;
    const navEnd = e as NavigationEnd;
    const parsedUrl = this.router.parseUrl(navEnd.urlAfterRedirects);
    const primarySegments = parsedUrl.root.children['primary']?.segments || [];
    const primaryPath = primarySegments.length > 0 ? primarySegments[0].path : '';
    const asidePath = this.asideRoutes[primaryPath];
    const currentAside = parsedUrl.root.children['aside'];
    const currentAsidePath = currentAside?.segments?.map((s: any) => s.path).join('/') || null;

    if (asidePath && currentAsidePath !== asidePath) {
        this._asideNavigating = true;
        const tree = this.router.createUrlTree([{outlets: {aside: [asidePath]}}], {relativeTo: null as any});
        tree.root.children['primary'] = parsedUrl.root.children['primary'];
        tree.queryParams = parsedUrl.queryParams;
        tree.fragment = parsedUrl.fragment;
        this.router.navigateByUrl(tree, {replaceUrl: true})
            .then(() => this._asideNavigating = false)
            .catch(() => this._asideNavigating = false);
    } else if (!asidePath && currentAside) {
        this._asideNavigating = true;
        delete parsedUrl.root.children['aside'];
        this.router.navigateByUrl(parsedUrl, {replaceUrl: true})
            .then(() => this._asideNavigating = false)
            .catch(() => this._asideNavigating = false);
    }
});
	}
	toggleDarkMode() {
	    const isDark = !this.darkMode();
	    this.darkMode.set(isDark);
	    this.document.body.classList.toggle('wa-dark', isDark);
	    localStorage.setItem('jwebmp-theme', isDark ? 'dark' : 'light');
	}
	changePrismTheme($event: any) {
	    const theme = $event?.detail?.item?.value || this.prismTheme;
	    this.prismTheme = theme;
	    localStorage.setItem('jwebmp-prism-theme', theme);
	
	    const applyThemeCss = (css: string) => {
	        let style = this.document.getElementById('prism-theme-override') as HTMLStyleElement;
	        if (!style) {
	            style = this.document.createElement('style') as HTMLStyleElement;
	            style.id = 'prism-theme-override';
	            this.document.head.appendChild(style);
	        }
	        style.textContent = css;
	    };
	
	    if (this._prismThemeCache[theme]) {
	        applyThemeCss(this._prismThemeCache[theme]);
	        return;
	    }
	
	    const url = `https://cdn.jsdelivr.net/npm/prismjs@1/themes/${theme}.min.css`;
	    fetch(url)
	        .then(r => r.ok ? r.text() : Promise.reject('Failed to load theme'))
	        .then(css => {
	            this._prismThemeCache[theme] = css;
	            applyThemeCss(css);
	        })
	        .catch(err => console.warn('Could not load Prism theme:', theme, err));
	}
	onBuildToolChange(value: boolean) {
	    this.useGradle = value;
	    localStorage.setItem('jwebmp-build-tool', value ? 'gradle' : 'maven');
	    window.dispatchEvent(new CustomEvent('jwebmp-build-tool-change', { detail: value }));
	}

}
